<template>
    <div class="flex flex-col border rounded font-semibold text-sm">
        <div class="px-3 py-4 flex items-center gap-4 border-b">
            <MiscIcon name="headset" />
            <a :href="`tel:${$t('checkout.phoneLink')}`" class="flex flex-col">
                <span>{{ $t('checkout.phone') }}</span>
                <span class="text-xs opacity-80 font-normal">{{ $t('checkout.openingHours') }}</span>
            </a>
        </div>
        <div class="px-3 py-4 flex items-center gap-4 border-b">
            <MiscIcon name="retoure" />
            <div>{{ $t('checkout.rightOfReturn') }}</div>
        </div>
        <div class="px-3 py-4 flex items-center gap-4">
            <MiscIcon name="arrow-left" />
            <div>{{ $t('checkout.freeReturn') }}</div>
        </div>
    </div>
</template>
